module.exports = __webpack_public_path__ + "static/img/ydh1-benefit-bg2.0d0c21ac.png";